import { createStore, del, get, set } from "idb-keyval";

import { STORAGE_KEYS } from "../app_constants";

export const LISTA_TREE_SNAPSHOT_VERSION = 1;

export interface ListaTreeItemSnapshot {
  name: string;
  children?: string[];
  handle?: any;
  isLoaded?: boolean;
}

export interface ListaTreeSnapshot {
  version: typeof LISTA_TREE_SNAPSHOT_VERSION;
  activePanel: "explorer" | "lista" | null;
  expandedItems: string[];
  treeItems: Record<string, ListaTreeItemSnapshot>;
}

const store = createStore(
  `${STORAGE_KEYS.IDB_LISTA_TREE}-db`,
  `${STORAGE_KEYS.IDB_LISTA_TREE}-store`,
);

const snapshotKey = "listaTreeSnapshot";

export const loadListaTreeSnapshot =
  async (): Promise<ListaTreeSnapshot | null> => {
    try {
      const snapshot = await get<ListaTreeSnapshot>(snapshotKey, store);
      if (!snapshot || snapshot.version !== LISTA_TREE_SNAPSHOT_VERSION) {
        return null;
      }

      if (!snapshot.treeItems?.root || !Array.isArray(snapshot.expandedItems)) {
        return null;
      }

      return snapshot;
    } catch (error) {
      console.warn("Failed to load Lista tree snapshot from IndexedDB:", error);
      return null;
    }
  };

export const saveListaTreeSnapshot = async (
  snapshot: ListaTreeSnapshot,
): Promise<void> => {
  try {
    await set(snapshotKey, snapshot, store);
  } catch (error) {
    console.warn("Failed to save Lista tree snapshot to IndexedDB:", error);
  }
};

export const clearListaTreeSnapshot = async (): Promise<void> => {
  try {
    await del(snapshotKey, store);
  } catch (error) {
    console.warn("Failed to clear Lista tree snapshot from IndexedDB:", error);
  }
};
